import * as React from "react";
import { Row, Col } from "antd";
import { PbrInput } from "../../PbrInput/PbrInput";
import { WrappedFormUtils } from "antd/lib/form/Form";
import "./confirmPassword.scss";
const compareToFirstPassword = props => {
  return (rule, value, callback) => {
    const form = props.form;
    if (value && value !== form.getFieldValue("password")) {
      callback("As duas senhas estão diferentes!");
    } else {
      callback();
    }
  };
};

export function ConfirmPassword(props: { form: WrappedFormUtils; label: string; placeholder: string; onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void }) {
  return (
    <Row className="confirm-password">
      <Col xs={24} md={24}>
        <PbrInput
          name="password"
          type="password"
          placeholder={props.placeholder}
          formItemProps={{ label: props.label }}
          formWrapper={props.form}
          rules={[
            { required: true, message: "A senha é obrigatória!" },
            { min: 8, message: "A senha deve possuir no mínimo 8 caracteres!" }
          ]}
          onChange={props.onChange}
        />

        <PbrInput
          name="confirmPassword"
          type="password"
          placeholder={props.placeholder ? "Confirme a senha" : ""}
          formWrapper={props.form}
          formItemProps={{ label: props.label ? "Confirme sua senha" : "" }}
          rules={[{ required: true, message: "Por favor, confirme a senha!" }, { validator: compareToFirstPassword(props) }]}
        />
      </Col>
    </Row>
  );
}

export { ConfirmPassword as default };



// WEBPACK FOOTER //
// ./src/components/common/Form/ConfirmPassword/ConfirmPassword.tsx